export * from "ce/AppRouter";
import { default as CE_AppRouter } from "ce/AppRouter";
export default CE_AppRouter;
